import React, { createContext, useContext } from 'react';

interface PortalRootContextType {
  portalRoot: HTMLElement | null;
}

const PortalRootContext = createContext<PortalRootContextType | undefined>(undefined);

export const PortalRootProvider: React.FC<{ children: React.ReactNode; portalRoot: HTMLElement | null }> = ({
  children,
  portalRoot,
}) => {
  return (
    <PortalRootContext.Provider value={{ portalRoot }}>
      {children}
    </PortalRootContext.Provider>
  );
};

export const usePortalRoot = () => {
  const context = useContext(PortalRootContext);
  if (context === undefined) {
    // This warning is okay if a component doesn't need a portalRoot and is outside the provider.
    // However, for tooltips that *should* use it, they should be wrapped.
    console.warn('usePortalRoot must be used within a PortalRootProvider. Returning null.');
    return { portalRoot: null };
  }
  return context;
};
